import { Route } from '@angular/router';
import { LayoutComponent } from 'app/layout/layout.component';
import { initialDataResolver } from './app.resolvers';
import { NoAuthGuard } from './api/services/cookie-jwt-auth/guards/noAuth.guard';
import { AuthGuard } from './api/services/cookie-jwt-auth/guards/auth.guard';
import { FeatureGuard } from './api/services/cookie-jwt-auth/guards/feature-guard';
import { BasicGuard } from './api/services/cookie-jwt-auth/guards/basic-guard';
import { AssetBoardComponent } from './views/admin/erp/assets/asset-board/asset-board.component';
import { UserRoleService } from './views/calibrations/shared/services/auth/user-role.service';
import { AccessGuard } from './views/calibrations/shared/guards/access.guard';
import { ReportsComponent } from './views/admin/pages/reporting/reports/reports.component';
import { PurchaseOrderBuilderComponent } from './views/admin/pages/purchase-orders/purchase-order-builder/purchase-order-builder.component';
import { PurchaseOrdersModule } from 'app/views/admin/pages/purchase-orders/purchase-orders.module';
import { PartPurchaseOrdersComponent } from './views/admin/pages/parts-register/part-purchase-orders/part-purchase-orders.component';
import { MarinePartRegisterListComponent } from 'app/views/admin/pages/marine-parts-register/marine-part-register-list.component';

// @formatter:off
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
export const appRoutes: Route[] = [

    // Redirect empty path to '/dashboard'
    {path: '', pathMatch : 'full', redirectTo: 'dashboard'},

    // Redirect signed-in user to the '/dashboard'
    //
    // After the user signs in, the sign-in page will redirect the user to the 'signed-in-redirect'
    // path. Below is another redirection for that path to redirect the user to the desired
    // location. This is a small convenience to keep all main routes together here on this file.
    {path: 'signed-in-redirect', pathMatch : 'full', redirectTo: 'dashboard'},

    // Auth routes for guests
    {
        path: '',
        // canActivate: [NoAuthGuard],
        // canActivateChild: [NoAuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            // {path: 'email-confirmed', loadChildren: () => import('app/views/auth/email-confirmed/email-confirmed.routes')},
            // {path: 'forgot-password', loadChildren: () => import('app/views/auth/forgot-password/forgot-password.routes')},
            // {path: 'reset-password', loadChildren: () => import('app/views/auth/reset-password/reset-password.routes')},
            {path: 'sign-in', loadChildren: () => import('app/views/auth/sign-in/sign-in.routes')},
            // {path: 'sign-up', loadChildren: () => import('app/views/auth/sign-up/sign-up.routes')}
        ]
    },

    // Auth routes for authenticated users
    // {
    //     path: '',
    //     canActivate: [AuthGuard],
    //     canActivateChild: [AuthGuard],
    //     component: LayoutComponent,
    //     data: {
    //         layout: 'empty'
    //     },
    //     children: [
    //         {path: 'sign-out', loadChildren: () => import('app/views/auth/sign-out/sign-out.routes')},
    //         {path: 'unlock-session', loadChildren: () => import('app/views/auth/unlock-session/unlock-session.routes')}
    //     ]
    // },

    // Landing routes
    {
        path: '',
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            {path: 'home',
            loadChildren: () =>
                import("app/views/landing/home/home.module").then(
                (m) => m.HomeModule
            )},
        ]
    },

    // Admin routes
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: initialDataResolver
        },
        children: [
            // Profile
            {
                path: 'profile', loadChildren: () => //import('app/views/admin/dashboard/dashboard.routes')
                    import("app/views/admin/profile/profile.module").then(
                    (m) => m.ProfileModule
                ),
            },

            // Dashboard
            {
                path: 'dashboard', loadChildren: () => //import('app/views/admin/dashboard/dashboard.routes')
                    import("app/views/admin/dashboard/dashboard.module").then(
                    (m) => m.DashboardModule
                ),
                data: { isHireDashboard: false },
            },

            // Project Management
            {path: 'project-management', canActivate: [FeatureGuard], canActivateChild: [FeatureGuard], children: [
                {path: 'dashboard',
                    loadChildren: () =>
                        import("app/views/admin/pages/project-dashboard/project-dashboard.module").then(
                        (m) => m.ProjectDashboardModule
                    ),
                },
                {path: 'projects',
                    loadChildren: () =>
                        import("app/views/admin/pages/projects/projects.module").then(
                        (m) => m.ProjectsModule
                    ),
                },
                {path: 'workload',
                    loadChildren: () =>
                        import("app/views/admin/pages/workload/workload.module").then(
                        (m) => m.WorkloadModule
                    ),
                },
            ]},



            // CRM
            {path: 'crm', canActivate: [FeatureGuard], canActivateChild: [FeatureGuard], children: [
                {path: 'dashboard',
                    loadChildren: () =>
                        import("app/views/admin/crm/crm-dashboard/crm-dashboard.module").then(
                        (m) => m.CrmDashboardModule
                    ),
                },
                {path: 'contacts',
                    loadChildren: () =>
                        import("app/views/admin/apps/contacts/contacts.module").then(
                        (m) => m.ContactsModule
                    ),
                },
                {path: 'leads',
                    loadChildren: () =>
                        import("app/views/admin/crm/leads-management/leads-management.module").then(
                        (m) => m.LeadsManagementModule
                    ),
                },
                {path: 'pipeline',
                    loadChildren: () =>
                        import("app/views/admin/crm/pipeline/sales-pipeline.module").then(
                        (m) => m.SalesPipelineModule
                    ),
                },
                {path: 'emails',
                    loadChildren: () =>
                        import("app/views/admin/apps/mailbox/mailbox.module").then(
                        (m) => m.MailboxModule
                    ),
                },
                {path: 'reporting',
                    loadChildren: () =>
                        import("app/views/admin/crm/reporting/reporting.module").then(
                        (m) => m.ReportingModule
                    ),
                },
            ]},

            // Hire
            {path: 'hire', canActivate: [FeatureGuard], canActivateChild: [FeatureGuard], children: [
                {path: 'dashboard',
                    loadChildren: () =>
                        // import("app/views/admin/crm/crm-dashboard/crm-dashboard.module").then(
                        // (m) => m.CrmDashboardModule
                        import("app/views/admin/dashboard/dashboard.module").then(
                        (m) => m.DashboardModule
                    ),
                    data: { isHireDashboard: true },
                },
                {
                    path: 'asset-board',
                    component: AssetBoardComponent,
                },
                {path: 'customers',
                    loadChildren: () =>
                        import("app/views/admin/apps/contacts/contacts.module").then(
                        (m) => m.ContactsModule
                    ),
                },
                {path: 'calendar',
                    loadChildren: () =>
                        import("app/views/admin/apps/calendar/calendar.module").then(
                        (m) => m.CalendarModule
                    ),
                },
                {path: 'assets',
                    loadChildren: () =>
                        import("app/views/admin/erp/assets/assets.module").then(
                        (m) => m.AssetsModule
                    ),
                },
                {path: 'hire-orders',
                    loadChildren: () =>
                        import("app/views/admin/pages/purchase-orders/purchase-orders.module").then(
                        (m) => m.PurchaseOrdersModule
                    ),
                },
                {path: 'invoicing',
                    loadChildren: () =>
                        import("app/views/admin/pages/invoice/invoice.module").then(
                        (m) => m.InvoiceModule
                    ),
                },
            ]},


            // Calibration
            {path: 'calibration', canActivate: [FeatureGuard], canActivateChild: [FeatureGuard], children: [

                {path: "clocking-in",
                    loadChildren: () =>
                        import("./views/calibrations/views/clocking-in/clocking-in.module").then(
                        (m) => m.ClockingInModule
                    ),
                },

                // mirror main dashboard under calibrations
                {path: 'my-dashboard',
                    loadChildren: () =>
                        import("app/views/admin/dashboard/dashboard.module").then(
                        (m) => m.DashboardModule
                    ),
                    data: { isHireDashboard: false, hideHeader: true },
                },

                {path: "dashboard",
                    loadChildren: () =>
                        import("./views/calibrations/views/dashboard/dashboard.module").then(
                        (m) => m.DashboardModule
                    ),
                    data: {
                        // accessLevels: UserRoleService.EVERYONE_ACCESS,
                        title: "Dashboard",
                    },
                    // canActivate: [AccessGuard],
                },

                {path: "servicing", canActivate: [BasicGuard],
                    loadChildren: () =>
                        import("./views/calibrations/views/repairs-and-calibrations/repairs-and-calibrations.module").then(
                        (m) => m.RepairsAndCalibrationsModule),
                    data: {
                        // accessLevels: UserRoleService.EVERYONE_ACCESS,
                        title: "Servicing",
                        breadcrumb: "Servicing",
                    },
                    // canActivate: [AccessGuard],
                },
                {path: "settings", canActivate: [BasicGuard],
                    loadChildren: () =>
                        import("./views/calibrations/views/settings/settings.module").then(
                        (m) => m.DLMSettingsModule
                        ),
                        data: {
                            // accessLevels: UserRoleService.EVERYONE_ACCESS,
                            title: "settings",
                        },
                        // canActivate: [AccessGuard],
                },
                {path: "form-10a",
                    loadChildren: () =>
                        import("./views/calibrations/views/form10a/form10a.module").then(
                        (m) => m.Form10aModule
                        ),
                        data: {
                            // accessLevels: UserRoleService.EVERYONE_ACCESS,
                            title: "Form 10a",
                        },
                },
                {path: "customers", canActivate: [BasicGuard],
                    loadChildren: () =>
                        import("./views/calibrations/views/customers/customers.module").then(
                        (m) => m.CustomersModule
                    ),
                    data: {
                        // accessLevels: UserRoleService.EVERYONE_ACCESS,
                        title: "Customers",
                        breadcrumb: "Customers",
                    },
                    // canActivate: [AccessGuard],
                },

                // {path: 'users'},
                // {path: 'warehouse-locations'},
                // {path: 'loadcell-types'},
                // {path: 'display-types'},
                // // {path: 'sla'},
                // {path: 'parts-register'},
                // {path: 'machines'},
                // {path: 'pressure-test'},
                // {path: 'equipment'},
                // // {path: 'labour'},
                // {path: 'measurements'},
                // {path: 'packaging'},
                // {path: 'faults'},
                // {path: 'rectification'},
            ]},

            //Production
            {path: 'production', canActivate: [FeatureGuard], canActivateChild: [FeatureGuard],
                loadChildren: () =>
                    import("app/views/admin/pages/production/production.module").then(
                    (m) => m.ProductionModule
                ),
            },

            // Part Register
            {path: 'part-register', canActivate: [BasicGuard], canActivateChild: [BasicGuard],
                loadChildren: () =>
                    import("app/views/admin/pages/parts-register/part-register.module").then(
                    (m) => m.PartRegisterModule
                ),
            },

            // Marine Part Register
            {path: 'marine-part-register', canActivate: [BasicGuard], canActivateChild: [BasicGuard],
                component: MarinePartRegisterListComponent,
            },

            //Purchase Orders
            {
                path     : 'purchase-orders',
                component: PartPurchaseOrdersComponent,
                children: [
                    {
                        path     : 'purchase-order-builder',
                        component: PurchaseOrderBuilderComponent,
                        data: {
                            isSupplier: true,
                        }
                    }
                ],
            },
            //Sales Orders
            {
                path: 'sales-orders',
                loadChildren: () =>
                    import("app/views/admin/crm/sales-orders/sales-orders.module").then(
                    (m) => m.SalesOrdersModule
                ),
            },

            // Product Register
            {path: 'product-register', canActivate: [BasicGuard], canActivateChild: [BasicGuard],
                loadChildren: () =>
                    import("app/views/admin/pages/product-register/product-register.module").then(
                    (m) => m.ProductRegisterModule
                ),
            },

            // Suppliers
            {path: 'suppliers', canActivate: [BasicGuard], canActivateChild: [BasicGuard],
                loadChildren: () =>
                    import("app/views/admin/installation/suppliers/suppliers.module").then(
                    (m) => m.SuppliersModule
                ),
            },

            // HR
            {path: 'hr', canActivate: [BasicGuard], canActivateChild: [BasicGuard],
                loadChildren: () =>
                    import("app/views/admin/erp/hr/hr.module").then(
                    (m) => m.HrModule
                ),
            },

            // Reports
            {path: 'reports', canActivate: [BasicGuard], canActivateChild: [BasicGuard],
                loadChildren: () =>
                    import("app/views/admin/pages/reporting/reporting.module").then(
                    (m) => m.ReportsModule
                ),
            },

            // Form Builder
            {path: 'form-builder', canActivate: [BasicGuard], canActivateChild: [BasicGuard],
                loadChildren: () =>
                    import("app/views/admin/pages/form-builder/elevated-forms.module").then(
                    (m) => m.ElevatedFormsModule
                ),
            },

            // Settings
            {path: 'settings', canActivate: [BasicGuard], canActivateChild: [BasicGuard],
                loadChildren: () =>
                    import("app/views/admin/pages/settings/settings.module").then(
                    (m) => m.SettingsModule
                ),
            },

            //Forms
            {path: 'forms',// canActivate: [FeatureGuard], canActivateChild: [FeatureGuard],
                loadChildren: () =>
                    import("app/views/admin/pages/hire-forms/hire-forms.module").then(
                    (m) => m.HireFormsModule
                )
            },

            // Help Center
            {path: 'help-center',
                loadChildren: () =>
                    import("app/views/admin/pages/help-center/help-center.routes")
            },

            // Workaround
            {path: 'unused', canActivate: [FeatureGuard], canActivateChild: [FeatureGuard], children: [
                // these error if not imported here - not sure why. The feature guard will prevent them from being accessible
                {path: 'pipeline',
                    loadChildren: () =>
                        import("app/views/admin/crm/pipeline/sales-pipeline.module").then(
                        (m) => m.SalesPipelineModule
                    ),
                },
                {path: 'documentations',
                    loadChildren: () =>
                        import("app/views/admin/installation/documentations/documentations.module").then(
                        (m) => m.DocumentationsModule
                    ),
                },
            ]},

            // 404 & Catch all
            {path: '**', redirectTo: '404-not-found'}
        ]
    }
];
